export default {
  headerContent: {
    title: 'Groupama Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Groupama Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Beklenmedik kazalara karşı sigortalı kişiyi ve yakınlarını koruma altına alan Groupama Sigorta ferdi kaza sigortası, gündelik yaşamda karşılaşılacak beklenmedik kazalara karşı güvence sunmaktadır. Bu güvence kapsamında kaza durumları kolay bir şekilde atlatılan durumlara dönüşmektedir.',
        '<strong>Groupama Sigorta ferdi kaza sigortası</strong> sigortalı kişinin kazaya uğraması sonucu kişiye vefat ya da maluliyet gibi durumlarda tazminat ödemesi yapan sigorta türüdür. Aynı zamanda sunulan imkânlar ile sigortalı kişinin yakınları da bu sigortadan yararlanabilmektedir.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası, her türlü kazayı içermesi için geniş bir alanda güvence sunmaktadır. Trafik kazaları, ev kazaları, iş kazaları, ısırılma, zehirli gazların solunması, kas ve sinir sisteminde oluşan hasarlar, kırık – çıkık gibi durumlara karşı güvence sunmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
